export default __webpack_public_path__ + "static/media/chevron-left.62a01d1b.svg";